import { PersonsType } from "@app/companyTab/@types/Customer";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { Button, colors, MEDIA_QUERY, Modal } from "@farzoom/common-ui-components";
import { Col, Row, Typography } from "antd";
import { useForm } from "react-hook-form";
import { createUseStyles } from "react-jss";
import { PersonInfoBlock } from "./personInfoBlock";
import { IdentityDocumentBlock } from "./identityDocumentBlock";
import { PersonRoles } from "./personRoles";

const { Title } = Typography;

type PersonInfoModalProps = {
  onClose: () => void;
  onUpdate: (values: PersonsType) => void;
  defaultValues: PersonsType;
  readonly: boolean;
};

export const useStyles = createUseStyles({
  container: {
    width: "clamp(600px, 85vw, 1300px)",
    position: "relative",
    [MEDIA_QUERY.mobile]: {
      width: "100%",
    },
    "& .ant-form-item": {
      marginBottom: 0,
    },
    "& [class*=formSelect] + [class*=formSelect]": {
      marginTop: 0,
    },
  },
  block: {
    backgroundColor: colors.cardBackground,
    padding: 16,
    borderRadius: 8,
    height: "100%",
  },
  rolesWrapper: {
    marginTop: 24,
  },
  btn: {},
  btnWrapper: {
    paddingTop: 16,
    paddingBottom: 4,
    position: "sticky",
    bottom: 0,
    backgroundColor: "white",
    display: "flex",
    justifyContent: "flex-end",
    gap: 16,
  },
  label: {
    fontFamily: "Roboto, sans-serif",
    color: "#8E909B",
    fontSize: 14,
  },
  modalTitle: {
    marginTop: "0.55em",
    marginBottom: "0.75em !important",
  },
  personModalWrap: {
    "& [class*=close]": {
      display: "none",
    },
  },
});

export const disabledDate = (current) => {
  const today = new Date();
  return current && current > today;
};

export const PersonInfoModal = ({
  onClose,
  onUpdate,
  defaultValues,
  readonly,
}: PersonInfoModalProps) => {
  const classes = useStyles();
  const {
    setValue,
    control,
    watch,
    getValues,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PersonsType>({
    defaultValues,
  });

  const personW = watch();

  const onOk = handleSubmit(() => onUpdate(getValues()));

  const onReadonlyOk = () => onClose();

  return (
    <Modal open={true} onClose={onClose} closePath={false} className={classes.personModalWrap}>
      <fieldset disabled={readonly}>
        <div className={classes.container}>
          <Title level={4} className={classes.modalTitle}>
            Сведения о физ.лице
          </Title>
          <VerticalSpace>
            <Row gutter={[16, 16]} align="stretch">
              <Col span={24} xl={12}>
                <PersonInfoBlock
                  control={control}
                  setValue={setValue}
                  personW={personW}
                  errors={errors}
                  getValues={getValues}
                  readonly={readonly}
                />
              </Col>
              <Col span={24} xl={12}>
                <IdentityDocumentBlock
                  control={control}
                  setValue={setValue}
                  personW={personW}
                  readonly={readonly}
                  getValues={getValues}
                />
              </Col>
            </Row>
          </VerticalSpace>

          <PersonRoles
            control={control}
            setValue={setValue}
            readonly={readonly}
            register={register}
            personW={personW}
          />
        </div>
      </fieldset>
      <div className={classes.btnWrapper}>
        {!readonly && <Button onClick={onReadonlyOk} text="Назад" type="outlined" />}
        <Button
          className={classes.btn}
          type="primary"
          text="ОК"
          onClick={readonly ? onReadonlyOk : onOk}
        />
      </div>
    </Modal>
  );
};
